import React from "react";
import { Box, Typography } from "@mui/material";
import HistoryIcon from "@mui/icons-material/History";

const EmptyState = ({
  title = "No data found",
  subtitle = "Try adjusting filters or come back later.",
  icon,
}) => {
  return (
    <Box
      sx={{
        p: 5,
        textAlign: "center",
        borderRadius: 4,
        border: "1px dashed",
        borderColor: "divider",
        backgroundColor: "#fff",
      }}
    >
      {icon || (
        <HistoryIcon
          sx={{
            fontSize: 48,
            color: "text.disabled",
            mb: 1,
          }}
        />
      )}

      <Typography variant="h6" fontWeight={700}>
        {title}
      </Typography>

      <Typography color="text.secondary">{subtitle}</Typography>
    </Box>
  );
};

export default EmptyState;
